import { useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider.js";
import clearStoredSession from "./clearStoredSession.js";
import { buildLoginRedirectFrom } from "./redirect.js";
import { endSessionOnce } from "./refreshSession.js";

// Chiusura locale della sessione, condivisa da interceptor, PersistentLogin e
// socket. Nessuna chiamata a /auth/logout: quando il refresh e' rifiutato il BE
// ha gia' cancellato il cookie. Esegue una sola volta finche' non arriva un
// nuovo access token (vedi noteAuth in AuthProvider).
// onEnd: pulizia dello stato dell'app (store, socket...), dopo quella della sessione.
// Callback stabile: legge setAuth/navigate/onEnd dall'ultimo render tramite ref.
const useEndSession = ({ onEnd } = {}) => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const latest = useRef({});
  latest.current = { setAuth, navigate, onEnd };

  return useCallback(
    () =>
      endSessionOnce(() => {
        // Path corrente da window.location (non da useLocation, che nell'interceptor
        // sarebbe stale) per tornarci dopo il re-login.
        const from = buildLoginRedirectFrom(
          `${window.location.pathname}${window.location.search}`
        );
        clearStoredSession(latest.current.setAuth);
        latest.current.onEnd?.();
        latest.current.navigate("/login", { state: { from } });
      }),
    []
  );
};

export default useEndSession;
